import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController, LoadingController, Platform, NavParams } from '@ionic/angular';
import { CashTrackingService } from '../../services/cash-tracking.service';
import { StorageService } from '../../services/storage.service';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-cash-tracking-end-tracking',
    templateUrl: './cash-tracking-end-tracking.page.html',
    styleUrls: ['./cash-tracking-end-tracking.page.scss'],
})
export class CashTrackingEndTrackingPage implements OnInit {

    cash_tracking_page = null;
    printer_paper_sizes = [];

    constructor(
        private navParams: NavParams,
        public modalController: ModalController,
        public alertController: AlertController,
        private cashTrackingService: CashTrackingService,
        public loadingController: LoadingController,
        private storageService: StorageService,
        private platform: Platform,
    ) { }

    ngOnInit() {

        this.cash_tracking_page = this.navParams.data.cash_tracking_page;

        this.storageService.get("printer_paper_sizes").then((printer_paper_sizes) => {

            if(printer_paper_sizes) {
                this.printer_paper_sizes = printer_paper_sizes;
            }

            this.platform.ready().then(() => {
                if(Capacitor.isNativePlatform()) {
                    this.storageService.get("receipt_printer").then((receipt_printer) => {
                        if(receipt_printer) {
                            if(!this.printer_paper_sizes.includes("thermal")) {
                                this.printer_paper_sizes.push("thermal");
                            }
                        }
                    });
                }
            });

        })
        .catch(() => {});

    }

    close() {
        this.modalController.dismiss();
    }

    printCashTrackingReport(printer_paper_size) {
        this.cash_tracking_page.printCashTrackingReport(printer_paper_size);
    }

    end() {
        this.cashTrackingService.deleteCashTracking().then(() => {
            this.modalController.dismiss();
        });
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

}
